import { FIELD_STATUS, FORM_STATUS, API_CALL_STATUS } from '../status';
import {
    SET_FULL_NAME_VALUE,
    SET_FULL_NAME_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    SET_TRIP_TYPE_VALUE,
    SET_TRIP_TYPE_VALID,
    SET_COVER_FOR_VALUE,
    SET_COVER_FOR_VALID,
    SET_DEPARTURE_COUNTRY_VALUE,
    SET_DEPARTURE_COUNTRY_VALID,
    SET_DESTINATION_COUNTRY_VALUE,
    SET_DESTINATION_COUNTRY_VALID,
    SET_DEPARTURE_DATE_VALUE,
    SET_DEPARTURE_DATE_VALID,
    SET_RETURN_DATE_VALUE,
    SET_RETURN_DATE_VALID,
    SET_NO_OF_TRAVELLERS_VALUE,
    SET_NO_OF_TRAVELLERS_VALID,
    SET_NO_OF_MINORS_VALUE,
    SET_NO_OF_MINORS_VALID,
    SET_SELECTED_COVER_VALUE,
    SET_SELECTED_COVER_VALID,
    FORM_INVALID_TRAVEL_UG_INSURANCE_FORM,
    FORM_VALID_TRAVEL_UG_INSURANCE_FORM,
    FORM_VALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM,
    FORM_INVALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM,
    CALCULATE_TRAVEL_UG_INSURANCE_PREMIUM_SUCCESS,
    TRAVEL_UG_INSURANCE_ADD_COVER,
    REINITIALIZE,
    SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS,
    SHARE_MOTOR_INSURANCE_QUOTE_FAILURE,
    SET_SHARE_EMAIL_VALUE,
    SET_SHARE_EMAIL_VALID,
    TRAVEL_UG_SHARE_QUOTE_VALUE,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    SET_DOB_VALUE,
    SET_DOB_VALID,
    FETCH_ALL_PRODUCTS_SUCCESS,
    FETCH_ALL_PRODUCTS_FAILURE,
    API_PRODUCTS_PENDING_TRANSITION,
    API_PRODUCTS_SUCCESS_TRANSITION,
    API_PRODUCTS_FAILURE_TRANSITION,
    API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM,
    API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM,
    API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM,
    SET_AGE_VALUE,
    SET_AGE_VALID,
    SELECTED_FORM_SET_VALUE,
    API_PENDING_TRANSITION_COUNTRIES,
    API_SUCCESS_TRANSITION_COUNTRIES,
    API_FAILURE_TRANSITION_COUNTRIES,
    API_FAILURE_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM,
    API_PENDING_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM,
    API_SUCCESS_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM,
    SET_COUNTRIES_VALUE,
    SET_TOTAL_NO_OF_TRAVELLERS_VALUE,
    API_PENDING_TRANSITION_USD_RATE,
    API_SUCCESS_TRANSITION_USD_RATE,
    API_FAILURE_TRANSITION_USD_RATE,
    SET_USD_RATE_VALUE,
    SET_UGX_PREMIUM_VALUE,
    SET_FIRST_NAME_VALUE,
    SET_FIRST_NAME_VALID,
    SET_MIDDLE_NAME_VALUE,
    SET_MIDDLE_NAME_VALID,
    SET_LAST_NAME_VALUE,
    SET_LAST_NAME_VALID,
    SET_NO_18_69_VALUE,
    SET_NO_18_69_VALID,
    SET_NO_70_75_VALUE,
    SET_NO_70_75_VALID,
    SET_NO_76_80_VALUE,
    SET_NO_76_80_VALID,
    SET_NO_81_85_VALUE,
    SET_NO_81_85_VALID,
    SET_CUSTOMER_ID,
    SET_DESTINATION_COUNTRIES_VALUE,
    SET_DEPARTURE_COUNTRIES_VALUE,
    CALCULATE_TRAVEL_UG_INSURANCE_ALTERNATE_PREMIUM_SUCCESS,
    SET_ALTERNATE_UGX_PREMIUM_VALUE,
    SET_ENABLE_DOWNLOAD_QUOTE_VALUE,
    SET_SHARE_EMAIL_BASE_64_VALUE,
    API_INITIAL_TRANSITIONS_SHARE_QUOTE_FORM,
    SET_SHOW_TAGGING_ERROR_MODAL,
    SET_TAGGING_ERROR_MESSAGE,
} from '../../actions/travelUg/quote';

export const initQuote = {
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    shareQuoteAPIStatus: null,
    addedCover: null,
    showShareModal: false,
    ugCmbObject: {
        __typename: 'Contentstack_call_me_back_ke',
        product: 'Travel Insurance Uganda',
        privacy_policy_url: '/privacy-policy',
        extra_fields: ['Email Address'],
    },
    products: null,
    apiPendingProducts: null,
    premiumCalculation: {
        value: null,
        status: null,
        error: null,
    },
    selectedForm: 'initial',
    showComparisonsTable: false,
    countries: null,
    departureCountries: null,
    destinationCountries: null,
    countriesApiCallStatus: null,
    usdRateApiCallStatus: null,
    usdRate: null,
    ugxPremium: null,
    alternateUgxPremium: null,
    totalNoOfTravellers: 0,
    alternatePremiumCalculation: {
        value: null,
        status: null,
        error: null,
    },
    enableDownloadQuote: false,
    showTaggingErrorModal: false,
    taggingErrorMessage: null,
    form: {
        fullName: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        tripType: { value: null, error: null, status: null },
        coverFor: { value: null, error: null, status: null },
        age: { value: null, error: null, status: null },
        departureCountry: { value: null, error: null, status: null },
        destinationCountry: { value: null, error: null, status: null },
        departureDate: { value: null, error: null, status: null },
        returnDate: { value: null, error: null, status: null },
        noOfTravellers: { value: null, error: null, status: null },
        noOfMinors: { value: null, error: null, status: null },
        adults18to69: { value: null, error: null, status: null },
        adults70to75: { value: null, error: null, status: null },
        adults76to80: { value: null, error: null, status: null },
        adults81to85: { value: null, error: null, status: null },
        selectedCover: { value: null, error: null, status: null },
        shareEmail: { value: null, error: null, status: null },
        shareEmailBase64: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        firstName: { value: null, error: null, status: null },
        middleName: { value: null, error: null, status: null },
        lastName: { value: null, error: null, status: null },
        customerId: { value: null, error: null, status: null },
    },
};

export default (state = initQuote, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case FORM_INVALID_TRAVEL_UG_INSURANCE_FORM:
            return {
                ...state,
                formStatus: FORM_STATUS.INVALID,
            };
        case FORM_VALID_TRAVEL_UG_INSURANCE_FORM:
            return {
                ...state,
                formStatus: FORM_STATUS.VALID,
            };

        case API_PENDING_TRANSITION_COUNTRIES:
            return { ...state, countriesApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_COUNTRIES:
            return { ...state, countriesApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_COUNTRIES:
            return { ...state, countriesApiCallStatus: API_CALL_STATUS.FAILURE };

        case SET_COUNTRIES_VALUE:
            return { ...state, countries: action.value };

        case SET_DESTINATION_COUNTRIES_VALUE:
            return { ...state, destinationCountries: action.value };

        case SET_DEPARTURE_COUNTRIES_VALUE:
            return { ...state, departureCountries: action.value };

        case API_PENDING_TRANSITION_USD_RATE:
            return { ...state, usdRateApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_USD_RATE:
            return { ...state, usdRateApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_USD_RATE:
            return { ...state, usdRateApiCallStatus: API_CALL_STATUS.FAILURE };

        case SET_USD_RATE_VALUE:
            return { ...state, usdRate: action.value };

        case SET_UGX_PREMIUM_VALUE:
            return { ...state, ugxPremium: action.value };

        case SET_ALTERNATE_UGX_PREMIUM_VALUE:
            return { ...state, alternateUgxPremium: action.value };

        case SET_TOTAL_NO_OF_TRAVELLERS_VALUE:
            return { ...state, totalNoOfTravellers: action.value };

        case FETCH_ALL_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.value,
            };

        case FETCH_ALL_PRODUCTS_FAILURE:
            return {
                ...state,
                products: action.error,
            };

        case API_PRODUCTS_PENDING_TRANSITION:
            return {
                ...state,
                apiPendingProducts: API_CALL_STATUS.PENDING,
            };

        case API_PRODUCTS_SUCCESS_TRANSITION:
            return {
                ...state,
                apiPendingProducts: API_CALL_STATUS.SUCCESS,
            };

        case API_PRODUCTS_FAILURE_TRANSITION:
            return {
                ...state,
                apiPendingProducts: API_CALL_STATUS.FAILURE,
            };

        case FORM_VALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM:
            return {
                ...state,
                shareQuoteFormStatus: FORM_STATUS.VALID,
            };

        case TRAVEL_UG_INSURANCE_ADD_COVER:
            return {
                ...state,
                addedCover: action.value,
            };

        case SET_ENABLE_DOWNLOAD_QUOTE_VALUE:
            return {
                ...state,
                enableDownloadQuote: action.value,
            };

        case SET_SHOW_TAGGING_ERROR_MODAL:
            return {
                ...state,
                showTaggingErrorModal: action.value,
            };

        case SET_TAGGING_ERROR_MESSAGE:
            return {
                ...state,
                taggingErrorMessage: action.value,
            };

        case FORM_INVALID_TRAVEL_UG_INSURANCE_QUOTE_SHARE_FORM:
            return {
                ...state,
                shareQuoteFormStatus: FORM_STATUS.INVALID,
            };

        case SET_CUSTOMER_ID:
            return updateFormField('customerId', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_TRIP_TYPE_VALUE:
            return updateFormField('tripType', (field) => ({
                ...field,
                value: action.value,
            }));

        case CALCULATE_TRAVEL_UG_INSURANCE_PREMIUM_SUCCESS:
            return {
                ...state,
                premiumCalculation: {
                    ...state.premiumCalculation,
                    value: action.value,
                    status: API_CALL_STATUS.SUCCESS,
                },
            };

        case CALCULATE_TRAVEL_UG_INSURANCE_ALTERNATE_PREMIUM_SUCCESS:
            return {
                ...state,
                alternatePremiumCalculation: {
                    ...state.alternatePremiumCalculation,
                    value: action.value,
                    status: API_CALL_STATUS.SUCCESS,
                },
            };

        case SET_TRIP_TYPE_VALID:
            return updateFormField('tripType', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SELECTED_FORM_SET_VALUE:
            return { ...state, selectedForm: action.value };

        case SET_FIRST_NAME_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_FIRST_NAME_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_MIDDLE_NAME_VALUE:
            return updateFormField('middleName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_MIDDLE_NAME_VALID:
            return updateFormField('middleName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_LAST_NAME_VALUE:
            return updateFormField('lastName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_LAST_NAME_VALID:
            return updateFormField('lastName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_FULL_NAME_VALUE:
            return updateFormField('fullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_FULL_NAME_VALID:
            return updateFormField('fullName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_AGE_VALUE:
            return updateFormField('age', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_AGE_VALID:
            return updateFormField('age', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_COVER_FOR_VALUE:
            return updateFormField('coverFor', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_COVER_FOR_VALID:
            return updateFormField('coverFor', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_DEPARTURE_COUNTRY_VALUE:
            return updateFormField('departureCountry', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_DEPARTURE_COUNTRY_VALID:
            return updateFormField('departureCountry', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_DESTINATION_COUNTRY_VALUE:
            return updateFormField('destinationCountry', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_DESTINATION_COUNTRY_VALID:
            return updateFormField('destinationCountry', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_DEPARTURE_DATE_VALUE:
            return updateFormField('departureDate', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_DEPARTURE_DATE_VALID:
            return updateFormField('departureDate', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_DOB_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_DOB_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_RETURN_DATE_VALUE:
            return updateFormField('returnDate', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_RETURN_DATE_VALID:
            return updateFormField('returnDate', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_NO_OF_TRAVELLERS_VALUE:
            return updateFormField('noOfTravellers', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_NO_OF_TRAVELLERS_VALID:
            return updateFormField('noOfTravellers', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_NO_OF_MINORS_VALUE:
            return updateFormField('noOfMinors', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_NO_OF_MINORS_VALID:
            return updateFormField('noOfMinors', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_NO_18_69_VALUE:
            return updateFormField('adults18to69', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_NO_18_69_VALID:
            return updateFormField('adults18to69', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_NO_70_75_VALUE:
            return updateFormField('adults70to75', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_NO_70_75_VALID:
            return updateFormField('adults70to75', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_NO_76_80_VALUE:
            return updateFormField('adults76to80', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_NO_76_80_VALID:
            return updateFormField('adults76to80', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_NO_81_85_VALUE:
            return updateFormField('adults81to85', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_NO_81_85_VALID:
            return updateFormField('adults81to85', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_SELECTED_COVER_VALUE:
            return updateFormField('selectedCover', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_SELECTED_COVER_VALID:
            return updateFormField('selectedCover', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        // Share modal
        case TRAVEL_UG_SHARE_QUOTE_VALUE:
            return {
                ...state,
                showShareModal: action.value,
            };

        case COLLECT_SHARE_QUOTE_FORM_DATA:
            return {
                ...state,
                shareQuoteFormStatus: FORM_STATUS.VALID,
            };

        case SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS:
            return {
                ...state,
                quoteShare: action.value,
            };

        case SHARE_MOTOR_INSURANCE_QUOTE_FAILURE:
            return {
                ...state,
                quoteShare: action.error,
            };

        case SET_SHARE_EMAIL_BASE_64_VALUE:
            return updateFormField('shareEmailBase64', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_SHARE_EMAIL_VALUE:
            return updateFormField('shareEmail', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_SHARE_EMAIL_VALID:
            return updateFormField('shareEmail', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case API_PENDING_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM:
            return {
                ...state,
                apiCallStatus: API_CALL_STATUS.PENDING,
            };
        case API_SUCCESS_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM:
            return {
                ...state,
                apiCallStatus: API_CALL_STATUS.SUCCESS,
            };
        case API_FAILURE_TRANSITION_TRAVEL_UG_INSURANCE_QUOTE_FORM:
            return {
                ...state,
                apiCallStatus: API_CALL_STATUS.FAILURE,
            };

        case API_INITIAL_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: null,
            };

        case API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: API_CALL_STATUS.PENDING,
            };

        case API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: API_CALL_STATUS.SUCCESS,
            };

        case API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: API_CALL_STATUS.FAILURE,
            };

        // Reset state
        case REINITIALIZE:
            return initQuote;
        default:
            return state;
    }
};
